import {default as RouteBuilderClass} from "./RouteBuilder"
import {Routes} from "./Routes";

const RouteBuilder = new RouteBuilderClass()

export { Routes, RouteBuilder }